export const downloadFile = (url: string, name = '') => {
  const el = document.createElement('a');
  el.setAttribute('href', url);
  el.setAttribute('download', name);
  el.setAttribute('rel', 'noreferrer');
  el.setAttribute('target', '_blank');
  el.style.display = 'none';
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
};